export default __webpack_public_path__ + "static/media/23.9bba4e58.jpg";